import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup/FormGroup";
import InputLabel from '@material-ui/core/InputLabel';
import {Field} from "formik";
import {Select} from "formik-material-ui";

import CustomInput from "components/CustomInput/CustomInput.js";

export default function AddressInput({formField, classes, states}) {
    
    return (
        <FormControl
            component="fieldset"
            className={classes.formControl + " " + classes.itemSpacer}
            style={{
                paddingBottom: "10px",
                margin: "27px 0 0 0",
                position: "relative",
                verticalAlign: "unset"
            }}
        >
            <FormLabel component="legend" style={{marginBottom: "5px"}}>{formField.label}</FormLabel>
            <FormGroup className={classes.formGroupHorizontal}>
                <Field
                    component={CustomInput}
                    labelText={formField.fields.street.label}
                    name={formField.fields.street.name}
                    id={formField.fields.street.name}
                    formControlProps={{
                        fullWidth: true,
                        style: {marginTop: "0px"}
                    }}
                    inputProps={{
                        multiline: true,
                        rows: 2
                    }}
                />
                <FormControl className={classes.groupedInput}>
                    <InputLabel htmlFor={formField.fields.state.name} className={classes.labelComponent + " MuiInputLabel-formControl"}>
                        {formField.fields.state.label}
                    </InputLabel>
                    <Field
                        component={Select}
                        label={formField.fields.state.label}
                        name={formField.fields.state.name}
                        id={formField.fields.state.name}
                        inputProps={{
                            name: formField.fields.state.name,
                            id: formField.fields.state.name
                        }}
                        className={classes.underline}
                    >
                        ({
                        states.map((prop, key) => <MenuItem key={key} value={prop.short}>{prop.long}</MenuItem>)
                    })
                    </Field>
                </FormControl>
                <Field
                    component={CustomInput}
                    labelText={formField.fields.postcode.label}
                    name={formField.fields.postcode.name}
                    id={formField.fields.postcode.name}
                    formControlProps={{
                        fullWidth: false,
                        className: classes.groupedInput
                    }}
                />
            </FormGroup>
        </FormControl>
    );
}